import React from "react";
import { titleCase } from "../lib/format";

const tone: Record<string, string> = {
  confirmed: "bg-[var(--moss)] text-[var(--paper)]",
  paid_out: "bg-[var(--moss)] text-[var(--paper)]",
  active: "bg-[var(--moss)] text-[var(--paper)]",
  delivered: "bg-[var(--moss)] text-[var(--paper)]",
  shipped: "bg-[var(--ink)] text-[var(--paper)]",
  processing: "bg-[var(--ink)] text-[var(--paper)]",
  pending: "border border-border text-neutral-600",
  draft: "border border-amber-600 text-amber-700",
  pending_submission: "border border-border text-neutral-600",
  submitted: "border border-border text-neutral-600",
  paused: "border border-border text-neutral-600",
  failed: "bg-[var(--wine)] text-[var(--paper)]",
  charged_back: "bg-[var(--wine)] text-[var(--paper)]",
  cancelled: "bg-neutral-300 text-neutral-700",
  open: "bg-[var(--wine)] text-[var(--paper)]",
  in_progress: "bg-[var(--ink)] text-[var(--paper)]",
  closed: "border border-border text-neutral-500",
  sent: "border border-border text-neutral-600",
  redeemed: "bg-[var(--moss)] text-[var(--paper)]",
  none: "border border-border text-neutral-500",
};

export function StatusBadge({ status, testId }: { status: string; testId?: string }) {
  return (
    <span className={`inline-block px-2 py-1 text-[10px] uppercase tracking-[0.15em] ${tone[status] || "border border-border text-neutral-600"}`} data-testid={testId}>
      {titleCase(status)}
    </span>
  );
}
